import {
  AuthRoutes,
  getAuthRouteFromPathname,
} from '@xarvio/frontend-core-router/lib/AuthRoutes';

export const isPublicAuthRoute = (pathname: string) =>
  getAuthRouteFromPathname(pathname) !== undefined;

export const isLoginRoute = (pathname: string) =>
  getAuthRouteFromPathname(pathname) === AuthRoutes.LOGIN;

export { getAuthRouteFromPathname as getAuthRoutePath };
